export function getImageSizeBySrc(
  src: string,
  options: { crossOrigin: string | null } = { crossOrigin: 'anonymous' }
): Promise<{ width: number; height: number }> {
  return new Promise<{ width: number; height: number }>((resolve, reject) => {
    if (!document) {
      reject(new Error('No document'));
    }

    const img = document.createElement('img');
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };

    img.crossOrigin = options.crossOrigin;
    img.src = src;
  });
}
